<template>
  <div class='scrambles-editor'>
    <v-container>
      <v-layout v-for='(scramble, i) in scrambles' :key='i'>
        <v-flex xs6><single-scramble :scramble='scramble' :type='scrambleType' /></v-flex>
        <v-flex xs2><v-btn @click='removeScramble(i)' small><v-icon>fas fa-minus</v-icon></v-btn></v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs6><v-textarea v-model='currScramble' placeholder='Enter multiple scrambles separated by new lines' /></v-flex>
        <v-flex xs2><v-btn @click='addScramble' color='blue'><v-icon color='black'>fas fa-plus</v-icon></v-btn></v-flex>
      </v-layout>
      <v-layout>
        <v-btn @click='updateScrambles' :disabled='this.scrambles.length === 0'>SUBMIT</v-btn>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import AdminService from '@/services/TPC/AdminService'
import RoundsService from '@/services/TPC/RoundsService'

import SingleScramble from '@/components/TPC/Shared/SingleScramble'

export default {
  name: 'scrambles-editor',
  components: {
    SingleScramble
  },
  data () {
    return {
      currScramble: '',
      scrambles: [],
      scrambleType: '3x3',
    }
  },
  props: {
    roundID: String,
    order: Number
  },
  methods: {
    async updateScrambles () {
      let order = this.order !== undefined ? (this.order !== -1 ? this.order - (this.order % 2) : -1) : undefined
      let resp = await AdminService.addScrambles({
        roundID: this.roundID,
        solverOrder: order,
        scrambles: this.scrambles
      })
      if (resp.data.error) {
        alert(resp.data.error + ' ' + resp.data.message)
      } else if (resp.data.success) {
        alert('Success')
      }
    },
    removeScramble (i) {
      this.scrambles.splice(i, 1)
    },
    addScramble () {
      let scrambles = this.currScramble.trim().split('\n').filter(Boolean)
      this.scrambles = this.scrambles.concat(scrambles)
      this.currScramble = ''
    }
  },
  async created () {
    let resp = await RoundsService.getScrambles({
      roundID: this.roundID,
      solverOrder: this.order
    })
    if (resp.data.success) {
      if (resp.data.scrambles.length > 0) {
        this.scrambleType = resp.data.scrambles[0].type
      }
      resp.data.scrambles.sort((a, b) => a.scramblenum - b.scramblenum)
      this.scrambles = resp.data.scrambles.filter(v => v.scramblestr).map(s => s.scramblestr)
    } else if (resp.data.error) {
      alert('ERROR: ' + resp.data.error + ': ' + resp.data.message)
    }
  },
}
</script>

<style>

</style>
